// extracted by mini-css-extract-plugin
var _1 = "CustomSelect-moduleafterIconContainer__CNztQ IconNG-moduleiconContainer__SxWZ0";
var _2 = "CustomSelect-moduleavatar__JmkC8";
var _3 = "CustomSelect-modulebutton__lwg6x";
var _4 = "CustomSelect-modulebuttonOpen__myiwS";
var _5 = "CustomSelect-moduleinput__qp2jd Input-moduleInput__GyKvb";
var _6 = "CustomSelect-moduleinputHidden__xH2Pb";
var _7 = "CustomSelect-moduleopen__dUga0";
var _8 = "CustomSelect-moduleopenIcon__qpKfY";
var _9 = "CustomSelect-moduleopenIconButton__zKkf9";
var _a = "CustomSelect-moduleselect__us4ve";
export { _1 as "afterIconContainer", _2 as "avatar", _3 as "button", _4 as "buttonOpen", _5 as "input", _6 as "inputHidden", _7 as "open", _8 as "openIcon", _9 as "openIconButton", _a as "select" }
